import {Injectable} from 'ng-metadata/core';
import {AbstractRequest} from '../abstractRequest';
import {FormBuilderEnums} from '../../../../../../../infra/formBuilder/formBuilder.service';


@Injectable()
export class AlmaPurchaseRequest extends AbstractRequest {
    constructor(){
        super();
        this.formFields = [
        {
                key: 'citationType',
                name: 'citationType',
                label: 'almaPurchaseRequest.citationType',
                value: 'book',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                existingPath: 'dummyPath',
                valuePath: 'citationType',
                uiType: FormBuilderEnums.UI_TYPE.RADIO_BUTTON,
                populator:  {
                    params:     {
                        defaultValuePath: 'citationType'
                    }
                },
                options:[
                    {
                        label:'almaPurchaseRequest.book',
                        value:'book'
                    },
                    {
                        label:'almaPurchaseRequest.journal',
                        value:'journal'
                    }
                ],
                events: {
                    onClick: this.onClick.bind(this),
                    params: []
                }

            },
             {
                key: 'title',
                name: 'title',
                label: 'almaPurchaseRequest.title',
                mandatory: true,
                valuePath: 'title',
                existingPath: 'title',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
             {
                key: 'author',
                name: 'author',
                label: 'almaPurchaseRequest.author',
                mandatory: false,
                valuePath: 'author',
                existingPath: 'author',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
             {
                key: 'edition',
                name: 'edition',
                label: 'almaPurchaseRequest.edition',
                mandatory: false,
                valuePath: 'edition',
                existingPath: 'edition',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
              {
                key: 'isbn',
                name: 'isbn',
                label: 'almaPurchaseRequest.isbn',
                mandatory: false,
                valuePath: 'isbn',
                existingPath: 'isbn',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'citationType', value: 'book'}
            },
            {
                key: 'issn',
                name: 'issn',
                label: 'almaPurchaseRequest.issn',
                mandatory: false,
                valuePath: 'issn',
                existingPath: 'issn',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'citationType', value: 'journal'}
            },
            {
                key: 'lccNumber',
                name: 'lccNumber',
                label: 'almaPurchaseRequest.lccNumber',
                mandatory: false,
                valuePath: 'lccNumber',
                existingPath: 'lccNumber',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'oclcNumber',
                name: 'oclcNumber',
                label: 'almaPurchaseRequest.oclcNumber',
                mandatory: false,
                valuePath: 'oclcNumber',
                existingPath: 'oclcNumber',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'publisher',
                name: 'publisher',
                label: 'almaPurchaseRequest.publisher',
                mandatory: false,
                valuePath: 'publisher',
                existingPath: 'publisher',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'publication_year',
                name: 'publication_year',
                label: 'almaPurchaseRequest.publication_year',
                mandatory: false,
                valuePath: 'publication_year',
                existingPath: 'publication_year',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'place_of_publication',
                name: 'place_of_publication',
                label: 'almaPurchaseRequest.place_of_publication',
                mandatory: false,
                valuePath: 'place_of_publication',
                existingPath: 'place_of_publication',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'volume',
                name: 'volume',
                label: 'almaPurchaseRequest.volume',
                mandatory: false,
                valuePath: 'volume',
                existingPath: 'volume',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'requesterNotes',
                name: 'requesterNotes',
                label: 'almaPurchaseRequest.requesterNotes',
                mandatory: false,
                valuePath: 'requesterNotes',
                existingPath: 'requesterNotes',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'requesterNotesAdditionalInfo',
                name: 'requesterNotesAdditionalInfo',
                label: 'almaPurchaseRequest.requesterNotesAdditionalInfo',
                mandatory: false,
                valuePath: 'requesterNotesAdditionalInfo',
                existingPath: 'requesterNotesAdditionalInfo',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN
            }
        ];
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/request/requestTypes/alma/almaPurchaseRequest.ts